export default __webpack_public_path__ + "static/05-c030578589f160a3ad57cda919c41e83.jpg";